<mat-list-item>
  @if (haveGroup()) {
    <mat-icon class="catalog-browser-layer-carret" matListItemIcon />
  }
  <span
    matListItemTitle
    matTooltipShowDelay="500"
    class="igo-list-item-with-text-overflow-ellipsis"
    [ngClass]="catalogAllowLegend() ? 'igo-cataloglayer-title' : ''"
    (click)="askForLegend()"
    [matTooltip]="computeTitleTooltip()"
  >
    {{ title }}
  </span>

  <div matListItemMeta>
    @if (layer().externalProvider) {
      <mat-icon
        class="igo-cataloglayer-external-icon"
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.catalog.externalProvider.layer' | translate"
        color="primary"
      >
        public
      </mat-icon>
    }
    <igo-metadata-button [layer]="$any(layer())" />

    @let isRange = inRange$ | async;
    @let isVisible = isVisible$ | async;
    @let isPreview = isPreview$ | async;
    <button
      (mouseenter)="onMouseEvent($event)"
      (mouseleave)="onMouseEvent($event)"
      mat-icon-button
      tooltip-position="below"
      matTooltipShowDelay="500"
      [matTooltip]="computeTooltip() | translate"
      [color]="isPreview ? '' : added() ? 'warn' : ''"
      (click)="onToggleClick($event)"
    >
      <mat-icon
        aria-hidden="false"
        matBadge="icon"
        [igoMatBadgeIcon]="getBadgeIcon()"
        igoMatBadgeColor="rgba(0,0,0,0.87)"
        igoMatBadgeBackgroundColor="none"
        [igoMatBadgeInverseColor]="true"
        [matBadgeHidden]="
          (isRange && isVisible) ||
          (isRange && !added()) ||
          (isRange && isPreview)
        "
        [matBadgeDisabled]="isRange === false"
        matBadgeSize="small"
        matBadgePosition="after"
      >
        {{ isPreview ? 'preview' : added() ? 'delete' : 'add' }}
      </mat-icon>
    </button>
  </div>
</mat-list-item>

<div #legend class="igo-cataloglayer-legend-container">
  @let igoLayer = igoLayer$ | async;
  @if ((layerLegendShown$ | async) && igoLayer && catalogAllowLegend()) {
    <igo-layer-legend [layer]="igoLayer" />
  }
</div>
